import { useLocation } from 'react-router-dom';

/* HOOKS */
export const useSearchParams = () => new URLSearchParams(useLocation().search);
